import Vue from "vue";
import i18n from "../../i18n/i18n";
import vuetify from '../../plugins/vuetify';
import "../../plugins/vuetify-dialog-promise";
import "../../plugins/cloudcore-vue-widgets";
import App from "./App";
import router from "./router";
import store from "./store";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.config.productionTip = false;

new Vue( {
    el : "#app",
    router,
    store,
    render : h => h( App ),
    vuetify,
    i18n
} ).$mount( "#app" );

